import { editCurrentProfile, fetchCurrentProfile } from "PFCore/services/current_profile";

export const CURRENT_PROFILE_ACTIONS = {
  CURRENT_PROFILE_SET: "CURRENT_PROFILE_SET",
  CURRENT_PROFILE_FAILED: "CURRENT_PROFILE_FAILED",
  CURRENT_PROFILE_UPDATE: "CURRENT_PROFILE_UPDATE"
};

export const currentProfileReducer = (state, action) => {
  switch (action.type) {
    case CURRENT_PROFILE_ACTIONS.CURRENT_PROFILE_SET:
      return {
        ...state,
        currentProfile: {
          loaded: state.currentProfile.loaded,
          logged_in: state.currentProfile.logged_in,
          ...action.payload
        },
        customTypes: action.payload.custom_types || state.customTypes
      };
    case CURRENT_PROFILE_ACTIONS.CURRENT_PROFILE_UPDATE:
      return {
        ...state,
        currentProfile: {
          ...state.currentProfile,
          ...action.payload
        }
      };
  }
};

export const CURRENT_PROFILE_ASYNC_ACTIONS = {
  CURRENT_PROFILE_FETCH: "CURRENT_PROFILE_FETCH",
  CURRENT_PROFILE_SAVE: "CURRENT_PROFILE_SAVE"
};

export const currentProfileDispatch = (dispatch, action) => {
  switch (action.type) {
    case CURRENT_PROFILE_ASYNC_ACTIONS.CURRENT_PROFILE_FETCH:
      fetchCurrentProfile().then((response) => {
        dispatch({
          type: CURRENT_PROFILE_ACTIONS.CURRENT_PROFILE_SET,
          payload: response
        });
      });
      break;
    case CURRENT_PROFILE_ASYNC_ACTIONS.CURRENT_PROFILE_SAVE:
      return new editCurrentProfile(action.payload).then(
        (response) => {
          dispatch({
            type: CURRENT_PROFILE_ACTIONS.CURRENT_PROFILE_SET,
            payload: { ...response, logged_in: true, loaded: true }
          });
          return response;
        },
        (errors) => {
          throw errors;
        }
      );
  }
};
